import x from './HuntHeader';

export default x;
